import { motion } from "framer-motion";
import { Bus, GraduationCap, HeartHandshake, ArrowUpRight } from "lucide-react";

const ITEMS = [
  {
    key: "School transport",
    icon: GraduationCap,
    title: "School transport",
    tag: "Educational stability",
    text: "Safe, reliable lifts to and from school so children and young people can keep attending, stay connected to their school and keep learning — even when home life changes.",
    points: ["Daily or regular school runs", "Keeping kids at the same school during moves", "Support to lift attendance"],
  },
  {
    key: "Family contact & appointments",
    icon: HeartHandshake,
    title: "Family contact & appointments",
    tag: "Mothers, children & young people",
    text: "Safe transport for mothers, children and young people to spend time with family and kinship carers, and to get to health, legal, Centrelink and other appointments.",
    points: ["Family time & kinship carer visits", "Medical, legal & agency appointments", "Planned, safe pick-ups and drop-offs"],
  },
];

export const SafeTransport = ({ onRequest }) => (
  <section id="transport" data-testid="safe-transport-section" className="scroll-mt-24 bg-sand px-5 pt-20 sm:px-10">
    <div className="mx-auto max-w-[1440px]">
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8 }} className="mb-10">
        <p className="eyebrow flex items-center gap-2 text-ochre"><Bus className="h-4 w-4" /> Safe transport</p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-medium leading-[1] tracking-tight sm:text-5xl">Getting there safely — to school, to family, to the help you need.</h2>
      </motion.div>
      <div className="grid gap-5 md:grid-cols-2">
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.key}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className={`flex flex-col rounded-[28px] p-8 sm:p-10 ${i === 0 ? "bg-gum text-sand" : "bg-ink text-sand"}`}
          >
            <div className="flex items-center justify-between">
              <it.icon className="h-9 w-9" strokeWidth={1.4} />
              <span className="rounded-full border border-sand/30 px-3 py-1 font-mono text-[11px] uppercase tracking-wider">{it.tag}</span>
            </div>
            <h3 className="mt-8 font-display text-4xl font-medium leading-none">{it.title}</h3>
            <p className="mt-4 text-sand/85">{it.text}</p>
            <ul className="mt-6 space-y-2 text-sm">
              {it.points.map((p) => <li key={p} className="border-t border-sand/15 pt-2">{p}</li>)}
            </ul>
            <button
              data-testid={`service-request-${it.key.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              onClick={() => onRequest(it.key)}
              className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-ochre px-6 py-3 text-sm font-semibold text-sand transition-colors hover:bg-ochre-dark"
            >
              Request transport <ArrowUpRight className="h-4 w-4" />
            </button>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
